import { LOADING, asUI } from "common/components/types";
import { GlideFunctionalRenderer } from "common/components/uis";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";

export const HoldContainerMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[childValue]] = useForceValueProducers(getValueProducers, force, ctx);
    if (childValue === LOADING) return env.renderProgress();

    return asUI(childValue).render(ctx, env);
};
